import React from 'react';
import { useTranslation } from 'react-i18next';
import ReportForm from '../ReportForm';

const RetentionReportOfSubmittedOrders:React.FC = () => {
    const { t } = useTranslation();

    return <ReportForm title={t('reports.RetentionDataOfSubmittedOrders.title')} serviceName="customCaseManagementServices" APIName="getRetentionReportOfSubmittedOrders" savedFileName={t('reports.RetentionDataOfSubmittedOrders.title')} />;
};

export default RetentionReportOfSubmittedOrders;
